module.exports = __webpack_public_path__ + "img/intro_tab3_1.3cff4522.png";